import { post } from "@/utils/api.config.js";
import { actions as authActions } from "@/utils/auth.js";

export const logoutApi = (params) => {
  const request = {
    subUrl: `/oauth/revoke`,
    headers: {
      "Content-Type": "application/json",
      Accept: "*",
      Authorization: "Bearer " + import.meta.env.VITE_AUTHORIZED_CLIENT_TOKEN,
      "Company-Token": authActions.getCompanyToken(),
    },
    data: params,
  };
  return post(request);
};
